// Modal para bloquear entidad APROBADA. Motivo obligatorio (>=5 chars,
// espejo de BloquearBody en backend/app/schemas/nutricionista.py).
import { useEffect, useState } from 'react'
import { ModalShell } from '../ui/ModalShell'

interface BloquearModalProps {
  entidadLabel: string
  onConfirm: (motivo: string) => Promise<void> | void
  onCancel: () => void
}

const MIN_MOTIVO = 5

export default function BloquearModal({
  entidadLabel,
  onConfirm,
  onCancel,
}: BloquearModalProps) {
  const [motivo, setMotivo] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape' && !submitting) onCancel()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onCancel, submitting])

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    const m = motivo.trim()
    if (m.length < MIN_MOTIVO) {
      setError(`El motivo debe tener al menos ${MIN_MOTIVO} caracteres`)
      return
    }
    setSubmitting(true)
    try {
      await onConfirm(m)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al bloquear')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <ModalShell
      title="Bloquear entidad"
      subtitle={entidadLabel}
      onClose={onCancel}
      closeDisabled={submitting}
      maxWidth={440}
    >
        <p className="text-xs text-amber-700 mb-3">
          Bloquear evita que esta entidad se use en menus / KDS futuros.
          La accion queda en bitacora.
        </p>
        <form onSubmit={handleSubmit} className="space-y-3">
          <label className="block">
            <span className="text-sm font-semibold">
              Motivo (mínimo {MIN_MOTIVO} caracteres)
            </span>
            <textarea
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              maxLength={500}
              rows={3}
              required
              minLength={MIN_MOTIVO}
              aria-label="Motivo de bloqueo"
              placeholder="Ej: Ingrediente descontinuado por proveedor."
              className="mt-1 w-full border rounded px-2 py-1 text-sm"
            />
          </label>

          {error && (
            <p role="alert" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded p-2">
              {error}
            </p>
          )}

          <div className="flex gap-2 pt-2">
            <button
              type="button"
              onClick={onCancel}
              disabled={submitting}
              className="flex-1 border py-2 rounded text-sm disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="flex-1 bg-avante-danger text-white py-2 rounded text-sm font-semibold disabled:opacity-50"
            >
              {submitting ? 'Bloqueando…' : 'Confirmar bloqueo'}
            </button>
          </div>
        </form>
    </ModalShell>
  )
}
